import { useState } from 'react'
import { DashboardLayout } from '../../components/layout'
import { Button, Modal } from '../../components/ui'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import { useDocuments, useProducts } from '../../hooks'
import { useToast } from '../../context/ToastContext'
import DocumentForm from '../../features/operations/DocumentForm'
import DocumentList from '../../features/operations/DocumentList'

const templates = [
  { title: 'Meeting Summary Prompt', anchor: 'meeting-summary-prompt' },
  { title: 'Decision Log Template', anchor: 'decision-log-template' },
  { title: 'Product Launch Checklist', anchor: 'product-launch-checklist' },
  { title: 'Expense Report Template', anchor: 'expense-report-template' },
  { title: 'Monthly Business Review Template', anchor: 'monthly-business-review-template' },
  { title: 'Interview Synthesis Prompt', anchor: 'interview-synthesis-prompt' },
  { title: 'Content Brief Template', anchor: 'content-brief-template' },
]

function DocsPage() {
  const { products, loading: productsLoading } = useProducts()
  const { documents, loading: documentsLoading, createDocument } = useDocuments()
  const [showAddModal, setShowAddModal] = useState(false)
  const [formLoading, setFormLoading] = useState(false)
  const toast = useToast()

  const handleCreateDocument = async (formData) => {
    setFormLoading(true)
    const { error } = await createDocument(formData)
    setFormLoading(false)

    if (error) {
      toast.error('Failed to add document')
      return
    }

    toast.success('Document added')
    setShowAddModal(false)
  }

  if (productsLoading || documentsLoading) {
    return (
      <DashboardLayout title="Docs">
        <LoadingSpinner.Overlay message="Loading documents..." />
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout
      title="Docs"
      actions={<Button onClick={() => setShowAddModal(true)}>+ Add Doc</Button>}
    >
      <div className="card mb-6">
        <h3 className="text-lg font-bold mb-2">AI-native Templates</h3>
        <p className="text-muted mb-4">Quick links to templates in the AI Operations Manual.</p>
        <div className="tag-row">
          {templates.map(template => (
            <a
              key={template.anchor}
              className="tag"
              href={`/docs/AI_OPERATIONS_MANUAL.md#${template.anchor}`}
              target="_blank"
              rel="noreferrer"
            >
              {template.title}
            </a>
          ))}
        </div>
      </div>

      <DocumentList documents={documents} />

      <Modal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title="Add Document Link"
      >
        <DocumentForm
          products={products}
          onSubmit={handleCreateDocument}
          onCancel={() => setShowAddModal(false)}
          loading={formLoading}
        />
      </Modal>
    </DashboardLayout>
  )
}

export default DocsPage
